require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-dynamics-365-dynamics-in-charities.json") })
        }
      }, "path---service-dynamics-365-dynamics-in-charities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-dynamics-365-dynamics-in-charities!./.cache/json/service-dynamics-365-dynamics-in-charities.json
// module id = 910
// module chunks = 231608221292675